<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card class="px-5 pt-5" elevation="0" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
          <v-row dense>
            <v-col cols="12" :sm="$canRoute('crypto-address') !== 1 ? 12 : 10">
              <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
                hide-details class="custom-v-input"></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" v-if="$canRoute('crypto-address') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialog"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn large tile block elevation="0" class="ma-0 text-capitalize btn-account" color="greenMain"
                    height="48px" v-bind="attrs" v-on="on">
                    Add New
                  </v-btn>
                </template>

                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                  ">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Add New Crypto Address
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    You Can Add New Crypto Address From Here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                    ">
                    <v-row>
                      <v-col cols="12">
                        <fieldset class="custom-upload-file">
                          <legend>Crypto Logo</legend>
                          <v-file-input v-model="cryptoData.file_url" label="Choose file (Max Size 2MB)" single-line
                            solo prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange"
                            :rules="fileRules"></v-file-input>
                          <v-img v-if="previewUrl" :src="previewUrl"></v-img>
                        </fieldset>
                        <span v-if="!cryptoData.file_url && errors.file_url" class="error-message">{{ errors.file_url
                        }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Enter Crypto Network</legend>
                          <v-select solo :items="networks" v-model="cryptoData.network" item-value="value"
                            item-text="title" append-icon="mdi-chevron-down" label="Click to Select"
                            class="custom-select" hide-details></v-select>
                        </fieldset>
                        <span v-if="!cryptoData.network && errors.network" class="error-message">{{ errors.network
                        }}</span>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Address</legend>
                          <v-text-field label="testtrc20address2" v-model="cryptoData.address" single-line solo
                            hide-details class="custom-select"></v-text-field>
                        </fieldset>
                        <span v-if="!cryptoData.address && errors.address" class="error-message">{{ errors.address
                        }}</span>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click="submitForm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
                          color="greenMain">
                          Submit
                        </v-btn>
                        <v-btn tile color="#FF567F" @click="handleClose" elevation="0"
                          class="text-capitalize btn-account px-sm-8">
                          Close
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense class="px-5">
      <v-col v-for="address in filteredAddresses" :key="address.id" cols="12" sm="6" md="6" lg="4">
        <v-card tile flat class="pa-5 broker-account-card" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <div class="image-section">
            <v-img max-width="130" :src="logoUrl(address?.file_url)"></v-img>
          </div>
          <div class="content-details">
            <ul>
              <li>
                <span class="sub-title">Method</span>
                <span class="titles">Crypto Transfer</span>
              </li>
              <li>
                <span class="titles address-container">
                  {{ shortenedAddress(address.address) }}

                  <v-btn small tile elevation="0" @click="copyAddress(address.id, address.address)"
                    class="ma-0 text-capitalize btn-account" color="greenMain" style="border-radius: 25px;">
                    {{ getCopyStatus(address.id) }}
                  </v-btn>
                </span>
              </li>
            </ul>
            <ul>
              <li>
                <span class="sub-title">Currency</span>
                <span class="titles">{{ address.network }}</span>
              </li>
            </ul>
          </div>
          <v-dialog v-if="$canRoute('crypto-address') === 1" transition="scale-transition" origin="center center" max-width="460"
            v-model="updateDialog[address.id]" content-class="deposit-withdraw-popup marketingPopup">
            <template v-slot:activator="{ on, attrs }">
              <v-btn large tile block elevation="0" class="ma-0 text-capitalize btn-account" color="greenMain"
                height="48px" v-bind="attrs" v-on="on">
                Update
              </v-btn>
            </template>

            <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
              <v-card-title class="pb-3 text-left justify-start pl-3">
                Update Crypto Address
              </v-card-title>
              <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                You Can Update Crypto Address From Here
              </v-card-subtitle>
              <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'
                ">
                <v-row>
                  <v-col cols="12">
                    <fieldset class="custom-upload-file">
                      <legend>Crypto Logo</legend>
                      <v-file-input disabled v-model="address.file_url" label="Choose file (Max Size 2MB)" single-line
                        solo prepend-icon="mdi-file-image" class="custom-select" @change="onFileChange"
                        :rules="fileRules"></v-file-input>
                      <v-img v-if="previewUrl || address.file_url" :src="previewUrl || address.file_url"
                        height="40"></v-img>
                    </fieldset>
                    <span v-if="!address.file_url && errors.file_url" class="error-message">{{ errors.file_url }}</span>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Enter Crypto Network</legend>
                      <v-select solo :items="networks" v-model="address.network" item-value="value" item-text="title"
                        append-icon="mdi-chevron-down" :label="address.network || 'Click to Select'"
                        class="custom-select" hide-details></v-select>
                    </fieldset>
                  </v-col>
                  <v-col cols="12">
                    <fieldset>
                      <legend>Address</legend>
                      <v-text-field v-model="address.address" label="testtrc20address2" single-line solo hide-details
                        class="custom-select"></v-text-field>
                    </fieldset>
                  </v-col>
                </v-row>
              </v-card>
              <v-card-actions>
                <v-row dense>
                  <v-col cols="12">
                    <v-btn tile @click="updateForm(address)" elevation="0"
                      class="text-capitalize btn-account mr-3 px-sm-8" color="greenMain">
                      Submit
                    </v-btn>
                    <v-btn tile color="#FF567F" @click="handleUpdateClose(address)" elevation="0"
                      class="text-capitalize btn-account px-sm-8">
                      Close
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CRYPTOADDRESS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      updateDialog: {},
      isCopied: false,
      copiedStates: {},
      fileRules: [
        (value) =>
          !value || value.size < 2000000 || "File size should be less than 2MB",
      ],
      networks: [
        { title: "USDT TRC-20", value: 'trc20' },
        { title: "USDT ERC-20", value: 'erc20' },
        { title: "USDT BEP-20", value: 'bep20' },
        { title: "ETHERUM", value: 'eth' },
        { title: "BNB", value: 'bnb' },
        { title: "BITCOIN", value: 'btc' }
      ],
      cryptoData: {
        network: "",
        address: "",
        file_url: "",
      },
      errors: {
        network: "",
        address: "",
        file_url: "",
      },
      fileError: false,
      previewUrl: null,
    };
  },

  computed: {
    ...mapState("cryptoaddress", ["cryptoaddress"]),
    ...mapState("admins", ["loggedAdmin"]),

    filteredAddresses() {
      const searchLower = this.search.toLowerCase();
      return this.cryptoaddress.filter(
        (address) =>
          address?.address?.toString()?.toLowerCase()?.includes(searchLower) ||
          address?.network?.toString()?.toLowerCase()?.includes(searchLower)
      );
    },
  },

  methods: {
    ...mapActions("cryptoaddress", [
      CRYPTOADDRESS__ACTIONS.GETCRYPTOADDRESS,
      CRYPTOADDRESS__ACTIONS.CREATECRYPTOADDRESS,
      CRYPTOADDRESS__ACTIONS.UPDATECRYPTOADDRESS,
    ]),

    shortenedAddress(address) {
      if (!address) return '';
      return `${address.slice(0, 6)}...${address.slice(-4)}`;
    },

    getCopyStatus(addressId) {
      return this.copiedStates[addressId] ? 'Copied!' : 'Copy';
    },

    async copyAddress(addressId, address) {
      try {
        await navigator.clipboard.writeText(address);
        this.$set(this.copiedStates, addressId, true);

        setTimeout(() => {
          this.$set(this.copiedStates, addressId, false);
        }, 1000);
      } catch (err) {
        console.error('Failed to copy address:', err);
      }
    },

    logoUrl(url) {
      return url || require("@/assets/bitcoin.png");
    },

    onFileChange(file) {
      if (file && file.size < 2000000) {
        this.cryptoData.file_url = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.cryptoData.file_url = null;
        this.previewUrl = null;
        this.fileError = true;
        this.errors.file_url = "File size should be less than 2MB";
      }
    },

    submitForm() {
      this.errors = {
        network: "",
        address: "",
        file_url: "",
      };

      const requiredFields = {
        network: "Network",
        address: "Address",
        file_url: "File",
      };

      Object.keys(requiredFields).forEach((field) => {
        if (!this.cryptoData[field]) {
          this.errors[field] = `${requiredFields[field]} is required`;
        }
      });

      // Handle file size error
      if (this.fileError) {
        this.errors.file_url = "File size should be less than 2MB";
        return;
      }

      // Check if there are any errors
      const hasErrors = Object.values(this.errors).some(
        (error) => error !== ""
      );

      if (!hasErrors) {
        this[CRYPTOADDRESS__ACTIONS.CREATECRYPTOADDRESS]({
          network: this.cryptoData.network,
          address: this.cryptoData.address,
          file_url: this.cryptoData.file_url,
        });
        this.handleClose();
      }
    },

    updateForm(item) {
      if (this.fileError) {
        this.errors.file_url = "File size should be less than 2MB";
      } else {
        this[CRYPTOADDRESS__ACTIONS.UPDATECRYPTOADDRESS]({
          id: item.id,
          network: item.network,
          address: item.address,
          file_url: this.cryptoData.file_url || null,
        });
        this.handleUpdateClose(item);
      }
    },

    handleClose() {
      this.dialog = false;
      this.previewUrl = null;
      this.cryptoData = {
        network: "",
        address: "",
        file_url: "",
      };
      this.errors = {
        network: "",
        address: "",
        file_url: "",
      };
    },

    handleUpdateClose(item) {
      this.$set(this.updateDialog, item?.id, false);
      this.fileError = false;
    },
  },

  async created() {
    await this[CRYPTOADDRESS__ACTIONS.GETCRYPTOADDRESS]();
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
  margin-top: 4px;
}
</style>
